export const NOTIFICATIONS_FREQUENCY = ["DAILY", "WEEKLY", "NEVER"];
